export default __webpack_public_path__ + "static/media/misc-closetB.f85f6d50.jpg";